import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

type DeleteGovernmentAllocationProps = {
  governmentAllocationId?: string
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

export const useDeleteGovernmentAllocation = ({
  governmentAllocationId,
  onSuccess,
  onError,
}: DeleteGovernmentAllocationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteGovernmentAllocation', governmentAllocationId],
    mutationFn: async () => {
      return privateAxios.delete(`/billing/government_allocations/${governmentAllocationId}`)
    },
    onSuccess,
    onError,
  })
}
